// extracted by mini-css-extract-plugin
module.exports = {"quizCategoriesModal":"QuizCategoriesModal_quizCategoriesModal__u23GZ","closeModalButton":"QuizCategoriesModal_closeModalButton__31zJ0","cycle":"QuizCategoriesModal_cycle__2j4xb"};